import { useCallback, useEffect, useState } from "react";
import { Certificate, getUserCertificates } from "crypto-pro";
import { message } from "antd";

/**
 * @returns возвращает список доступных сертификатов
 */
export const useDataCrypto = () => {
  const [dataCrypto, setDataCrypto] = useState<Certificate[]>([]);

  const takeAllCertificates = useCallback(async () => {
    await getUserCertificates()
      .then((res) => {
        setDataCrypto(res);
      })
      .catch((error: unknown) => {
        if (error instanceof Error) {
          message.error(error.message);
        }
      });
  }, []);

  useEffect(() => {
    takeAllCertificates();
  }, [takeAllCertificates]);

  return { dataCrypto };
};
